import PopupWithDimmedBackground from 'components/PopupWithDimmedBackground';
import RoundedButton from 'components/RoundedButton';
import Subheading from 'components/Subheading';
import { useState } from 'react';
import { ASSET_PREFIX } from 'utils/constants';

interface IFeedbackPopupProps {
  rating: number;
  onClose: (comment: string) => void;
}

const FeedbackPopup = ({ rating, onClose }: IFeedbackPopupProps) => {
  const [comment, setComment] = useState('');

  return (
    <PopupWithDimmedBackground
      onClose={() => {
        onClose('');
      }}
    >
      {rating >= 3 ? (
        <>
          <Subheading>
            Any <strong>feedback?</strong>
          </Subheading>
          <p className="aboutUsTypographyBodySmall">
            We always aim to deliver a 5-star experience and your feedback
            really helps.
          </p>
          <p className="aboutUsTypographyBodySmall">
            Please let us know if there's anything we can do to improve or
            anything we're doing right!
          </p>
        </>
      ) : (
        <>
          <img
            src={`${ASSET_PREFIX}/images/prizes/sad-face.svg`}
            style={{ height: '80px' }}
          />
          <Subheading>
            Oh <strong>No!</strong>
          </Subheading>
          <p>We always aim to deliver a 5-star experience.</p>
          <p>Please let us know what we can do better below.</p>
        </>
      )}

      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        style={{
          marginTop: '12px',
          padding: '1em',
          width: '90%',
          minHeight: '100px',
          borderRadius: '4px',
          border: '3px solid #CCC',
          fontSize: '16px',
        }}
      />

      <RoundedButton
        onClick={() => {
          onClose(comment);
        }}
        style={{ marginTop: '1em', width: '100%', maxWidth: '290px' }}
      >
        Submit Feedback
      </RoundedButton>

      <style jsx>{`
        p {
          font-size: 1.25em;
        }
      `}</style>
    </PopupWithDimmedBackground>
  );
};

export default FeedbackPopup;
